(function() {
  if (getSession().user) {
    document.body.classList.remove("session-guest");
    document.body.classList.add("session-user");
  } else {
    document.body.classList.remove("session-user");
    document.body.classList.add("session-guest");
  }

  function getSession() {
    const mainNavigation = document.querySelector(".main-navigation");

    return {
      guest:
        mainNavigation?.classList.contains("session-guest") ||
        document.body.classList.contains("session-guest"),
      user:
        mainNavigation?.classList.contains("session-user") ||
        document.body.classList.contains("session-user"),
      cookie: document.body.classList.contains("session-cookie")
    };
  }

  function scrollToDemo() {
    const downloadBtn = document.querySelector(".metatrader-scrolldown");

    if (!downloadBtn) {
      return;
    }

    downloadBtn.addEventListener("click", function() {
      if (getSession().guest && !getSession().cookie) {
        downloadBtn.setAttribute("href", "#form-info-container");
      }
    });
  }

  function downloadFile() {
    let download = document.querySelector(".download");
    let trCookie = document.cookie.match(
      new RegExp("(^| )" + "tr_sign-up" + "=([^;]+)")
    );
    let params = new URLSearchParams(document.location.search);
    let userType = params.get("user_type");

    if (!download) {
      return;
    }

    if (trCookie || (userType && userType === "old")) {
      if (download instanceof HTMLElement) {
        download.click();
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function() {
    scrollToDemo();
    downloadFile();
  });
})();
